// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var RatingSmileySet$ReactHooksTemplate = require("./ratingSmileySet.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SmileyRatingDefaultForm$ReactHooksTemplate = require("./SmileyRatingDefaultForm.res.js");

function SmileyRatingForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var surveyTheme = props.surveyTheme;
  var smileyRating = props.smileyRating;
  var style = function (selected) {
    if (selected) {
      return {
              borderColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(surveyTheme),
              borderWidth: "1px",
              outline: "None"
            };
    } else {
      return {
              outline: "None"
            };
    }
  };
  var smileyButton = function (ratingType, ratingSmileySet, selected) {
    return JsxRuntime.jsxs("button", {
                children: [
                  JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsx("img", {
                              className: "small:h-32-px h-auto",
                              src: SmileyRating$ReactHooksTemplate.ratingTypeToImage(ratingType, ratingSmileySet)
                            }),
                        className: "text-5xl small:text-4xl"
                      }),
                  SmileyRating$ReactHooksTemplate.showLabels(smileyRating) ? JsxRuntime.jsx("div", {
                          children: SmileyRating$ReactHooksTemplate.ratingLabelToString(smileyRating, ratingType, SurveyLanguage$ReactHooksTemplate.name(language)),
                          className: "text-xs"
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                ],
                className: "animated bounceIn flex flex-col items-center p-2 w-1/5 gap-1",
                style: style(selected),
                onClick: (function (e) {
                    e.preventDefault();
                    Curry._1(onChange, SmileyRating$ReactHooksTemplate.setAnswer(smileyRating, ratingType));
                  })
              }, String(SmileyRating$ReactHooksTemplate.ratingTypeToRating(ratingType)));
  };
  var match = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(SmileyRatingDefaultForm$ReactHooksTemplate.make, {
                  smileyRating: smileyRating,
                  surveyTheme: surveyTheme,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  var match$1 = SmileyRating$ReactHooksTemplate.ratingSmileySet(smileyRating);
  var tmp;
  if (match$1 !== undefined) {
    var ratingSmileySet = SmileyRating$ReactHooksTemplate.ratingSmileySet(smileyRating);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                  text: SmileyRating$ReactHooksTemplate.text(smileyRating),
                  description: SmileyRating$ReactHooksTemplate.description(smileyRating),
                  mandatory: mandatory,
                  surveyTheme: surveyTheme,
                  substitutionVariables: substitutionVariables
                }),
            JsxRuntime.jsx("div", {
                  children: ratingSmileySet !== undefined ? $$Array.of_list(Belt_List.map(SmileyRating$ReactHooksTemplate.ratingTypeCollection(smileyRating), (function (xs) {
                                var match = SmileyRating$ReactHooksTemplate.answer(smileyRating);
                                var match$1 = RatingSmileySet$ReactHooksTemplate.selectedStateRatingSmileySet(ratingSmileySet);
                                if (match !== undefined) {
                                  if (match$1 !== undefined) {
                                    return smileyButton(xs, xs === match ? match$1 : ratingSmileySet, false);
                                  } else {
                                    return smileyButton(xs, ratingSmileySet, xs === match);
                                  }
                                } else {
                                  return smileyButton(xs, ratingSmileySet, false);
                                }
                              }))) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  className: "flex w-full justify-between pb-5"
                }),
            JsxRuntime.jsx("div", {
                  children: mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                          language: language
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                })
          ],
          className: "flex flex-col py-8 px-16 small:px-6"
        });
  } else {
    tmp = JsxRuntime.jsx("p", {
          children: "Loading..."
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp
            });
}

var make = SmileyRatingForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
